export { default } from "./ForgotForm";



// WEBPACK FOOTER //
// ./src/screens/Login/ForgotForm/index.ts